import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { labRequestReport } from '../../../helpers/adipiBackendUrl';
import { getTable, postApiCall, patchApiCall, deleteApiCall} from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTREPORT,
  DELETE_LABREQUESTREPORT,
  GET_LABREQUESTREPORTS,
  UPDATE_LABREQUESTREPORT
} from "./actionTypes";
import {
  addLabRequestReportFail,
  addLabRequestReportSuccess,
  deleteLabRequestReportFail,
  deleteLabRequestReportSuccess,
  getLabRequestReportsFail,
  getLabRequestReportsSuccess,
  setState,
  updateLabRequestReportFail,
  updateLabRequestReportSuccess,
} from "./actions";
//Include Both Helper File with needed methods

function* fetchLabRequestReports( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable,labRequestReport, params.toString());
    yield put(setState(false))
    yield put(getLabRequestReportsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestReportsFail(error));
  }
}

function* updateLabRequestReport ({payload: labRequestReportObj }) {
  try {
    const { id, recordStatus, ...rest } = labRequestReportObj;
    yield call(patchApiCall, `${labRequestReport}/${id}`, rest);
    const response = yield call(getTable,`${labRequestReport}/${labRequestReportObj.id}`);
    yield put(updateLabRequestReportSuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateLabRequestReportFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* deleteLabRequestReport ({payload: labRequestReportObj}) {
  try {
    yield call(deleteApiCall,`${labRequestReport}/${labRequestReportObj.id}` );
    yield put(deleteLabRequestReportSuccess(labRequestReportObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteLabRequestReportFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingLabRequestReport ({ payload: labRequestReportObj}) {
  try {
    const response = yield call(postApiCall, labRequestReport ,labRequestReportObj);
    const response2 = yield call(getTable,`${labRequestReport}/${response.id}`);
    yield put(addLabRequestReportSuccess(response2));
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(addLabRequestReportFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* labRequestReportsSaga() {
  yield takeEvery(GET_LABREQUESTREPORTS, fetchLabRequestReports);
  yield takeEvery(ADD_NEW_LABREQUESTREPORT, postingLabRequestReport);
  yield takeEvery(UPDATE_LABREQUESTREPORT, updateLabRequestReport);
  yield takeEvery(DELETE_LABREQUESTREPORT, deleteLabRequestReport);
}

export default labRequestReportsSaga;
